import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa9485c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkInvoiceEdit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title mb-3" }, "О грузе", -1))
const _hoisted_3 = { class: "grid-2" }
const _hoisted_4 = { class: "grid-2" }
const _hoisted_5 = { class: "grid-3" }
const _hoisted_6 = { class: "grid-3" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Обрешетка", -1))
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Мягкая упаковка", -1))
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Паллета", -1))
const _hoisted_13 = { class: "mb-3 flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Возвратные документы"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-blue-500" }, " Платная услуга ")
], -1))
const _hoisted_15 = { class: "grid-2" }
const _hoisted_16 = { class: "grey-block" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Страхование", -1))
const _hoisted_19 = { class: "grey-block" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Опасный груз", -1))
const _hoisted_22 = { class: "grey-block mb-3" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Температурный режим", -1))
const _hoisted_25 = { class: "grey-block mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title mb-3" }, "Транспорт доставки", -1))
const _hoisted_27 = { class: "mb-5 flex items-center justify-between" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "grey-block mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Кто оплачивает", -1))
const _hoisted_31 = { class: "grey-block mb-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Способ оплаты за доставку", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_input = _resolveComponent("ok-input")!
  const _component_ok_textarea = _resolveComponent("ok-textarea")!
  const _component_ok_checkbox = _resolveComponent("ok-checkbox")!
  const _component_ok_file = _resolveComponent("ok-file")!
  const _component_ok_select = _resolveComponent("ok-select")!
  const _component_ok_radio = _resolveComponent("ok-radio")!
  const _component_ok_button = _resolveComponent("ok-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ok_input, {
        name: "Название товара",
        placeholder: "Например: Счетчики газа",
        value: _ctx.state.product_name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.product_name) = $event)),
        "is-invalid": _ctx.state_form$.product_name.$error,
        "validation-errors": _ctx.state_form$.product_name.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_ok_input, {
        name: _ctx.customInvoiceNumberPlaceholder,
        placeholder: "Например: SP6754378708-0",
        value: _ctx.state.customer_invoice_number,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.customer_invoice_number) = $event)),
        "is-invalid": _ctx.state_form$.customer_invoice_number.$error,
        "validation-errors": _ctx.state_form$.customer_invoice_number.$errors
      }, null, 8, ["name", "value", "is-invalid", "validation-errors"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ok_input, {
        name: "Вес груза (кг)",
        placeholder: "Например: 12 кг",
        value: _ctx.state.weight,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.weight) = $event)),
        "is-invalid": _ctx.state_form$.weight.$error,
        "validation-errors": _ctx.state_form$.weight.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_ok_input, {
        name: "Количество мест",
        placeholder: "Например: 1",
        value: _ctx.state.places,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.places) = $event)),
        "is-invalid": _ctx.state_form$.places.$error,
        "validation-errors": _ctx.state_form$.places.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ok_input, {
        name: "Длинна (см)",
        placeholder: "Например: 50 см",
        value: _ctx.state.depth,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.depth) = $event)),
        "is-invalid": _ctx.state_form$.depth.$error,
        "validation-errors": _ctx.state_form$.depth.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_ok_input, {
        name: "Ширина (см)",
        placeholder: "Например: 50 см",
        value: _ctx.state.width,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.width) = $event)),
        "is-invalid": _ctx.state_form$.width.$error,
        "validation-errors": _ctx.state_form$.width.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_ok_input, {
        name: "Высота (см)",
        placeholder: "Например: 50 см",
        value: _ctx.state.height,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.height) = $event)),
        "is-invalid": _ctx.state_form$.height.$error,
        "validation-errors": _ctx.state_form$.height.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _createVNode(_component_ok_textarea, {
      class: "mb-3",
      name: "Примечание к отправке",
      placeholder: "Введите комментарий",
      rows: 4,
      value: _ctx.state.annotation,
      "onUpdate:value": _ctx.onUpdateAnnotation
    }, null, 8, ["value", "onUpdate:value"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ok_checkbox, {
          checked: _ctx.additional_services.hasGrid,
          onClick: _ctx.triggerGrid
        }, null, 8, ["checked", "onClick"]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ok_checkbox, {
          checked: _ctx.additional_services.hasSoftPackage,
          onClick: _ctx.triggerSoftPackage
        }, null, 8, ["checked", "onClick"]),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_ok_checkbox, {
          checked: _ctx.additional_services.hasPallet,
          onClick: _ctx.triggerPallet
        }, null, 8, ["checked", "onClick"]),
        _hoisted_12
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_ok_checkbox, {
        checked: Boolean(_ctx.state.is_return_documents),
        onClick: _ctx.triggerReturn
      }, null, 8, ["checked", "onClick"]),
      _hoisted_14
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_ok_checkbox, {
            checked: Boolean(_ctx.state.is_ensure),
            onClick: _ctx.triggerEnsure
          }, null, 8, ["checked", "onClick"]),
          _hoisted_18
        ]),
        _createVNode(_component_ok_input, {
          class: "OkInput--white",
          name: "Наименование груза",
          placeholder: "Введите наименование груза",
          value: _ctx.state.cargo_name,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.cargo_name) = $event)),
          "is-invalid": _ctx.state_form$.cargo_name.$error,
          "validation-errors": _ctx.state_form$.cargo_name.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        (_ctx.state.is_ensure)
          ? (_openBlock(), _createBlock(_component_ok_input, {
              key: 0,
              class: "OkInput--white",
              name: "Объявленая стоимость груза, тенге",
              placeholder: "Введите стоимость груза в тенге",
              value: _ctx.state.declared_price,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.declared_price) = $event)),
              maska: _ctx.PRICE_MASK
            }, null, 8, ["value", "maska"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_ok_checkbox, {
            checked: Boolean(_ctx.state.is_dangerous),
            onClick: _ctx.triggerDanger
          }, null, 8, ["checked", "onClick"]),
          _hoisted_21
        ]),
        (_ctx.state.is_dangerous)
          ? (_openBlock(), _createBlock(_component_ok_file, {
              key: 0,
              value: _ctx.files_state.invoice_files,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.files_state.invoice_files) = $event)),
              name: "Загрузите файл накладной",
              placeholder: "Загрузите файл накладной",
              disabled: _ctx.state.is_loading,
              "is-invalid": _ctx.files_state_form$.invoice_files.$error,
              "validation-errors": _ctx.files_state_form$.invoice_files.$errors,
              accept: "all",
              multiple: ""
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
          : _createCommentVNode("", true),
        (_ctx.state.is_dangerous)
          ? (_openBlock(), _createBlock(_component_ok_file, {
              key: 1,
              value: _ctx.files_state.certificate_of_safety_files,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.files_state.certificate_of_safety_files) = $event)),
              name: "Загрузите сертификат безопасности",
              placeholder: "Загрузите сертификат безопасности",
              disabled: _ctx.state.is_loading,
              "is-invalid": _ctx.files_state_form$.certificate_of_safety_files.$error,
              "validation-errors": _ctx.files_state_form$.certificate_of_safety_files.$errors,
              accept: "all",
              multiple: ""
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_ok_checkbox, {
          checked: Boolean(_ctx.state.is_temperature_regime_active),
          onClick: _ctx.triggerTemperature
        }, null, 8, ["checked", "onClick"]),
        _hoisted_24
      ]),
      (_ctx.state.is_temperature_regime_active)
        ? (_openBlock(), _createBlock(_component_ok_select, {
            key: 0,
            class: "OkSelect--white",
            value: _ctx.state.temperature_regime_type_id,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.temperature_regime_type_id) = $event)),
            name: "Температурный режим",
            placeholder: "Выберите температурный режим",
            options: _ctx.data_state.temperature_regimes.list,
            loading: _ctx.data_state.temperature_regimes.is_loading,
            failed: _ctx.data_state.temperature_regimes.is_failed,
            "error-text": "При получении списка причин произошла ошибка",
            disabled: _ctx.data_state.temperature_regimes.is_loading,
            "is-invalid": _ctx.state_form$.temperature_regime_type_id.$error,
            "validation-errors": _ctx.state_form$.temperature_regime_type_id.$errors,
            searchable: false,
            label: "title",
            onRefresh: _ctx.loadTemperatureRegimes
          }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors", "onRefresh"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_ok_input, {
        class: "OkInput--white",
        name: "Наложенный платеж",
        placeholder: "Введите стоимость в тенге",
        value: _ctx.state.cod_payment,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.cod_payment) = $event)),
        maska: _ctx.PRICE_MASK
      }, null, 8, ["value", "maska"])
    ]),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ltlShipmentTypes, (type, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `type-${idx}`,
          class: _normalizeClass([
                    'buttons__button',
                    {
                        'button--active': _ctx.isTypeActive(type.id),
                    },
                ]),
          onClick: ($event: any) => (_ctx.onSelectType(type.id))
        }, _toDisplayString(type.name), 11, _hoisted_28))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createVNode(_component_ok_radio, {
        options: _ctx.PAYMENT_TYPE_OPTIONS,
        value: _ctx.state.payment_type,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.payment_type) = $event)),
        onChange: _ctx.onPaymentTypeChange
      }, null, 8, ["options", "value", "onChange"]),
      (_ctx.isOnPayerSelect)
        ? (_openBlock(), _createBlock(_component_ok_select, {
            key: 0,
            class: "OkSelect--white",
            value: _ctx.state.payer_company_id,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.payer_company_id) = $event)),
            name: "Плательщик",
            placeholder: "Выберите плательщика",
            options: _ctx.data_state.payers.list,
            loading: _ctx.data_state.payers.is_loading,
            failed: _ctx.data_state.payers.is_failed,
            "error-text": "При получении списка компаний произошла ошибка",
            "is-invalid": _ctx.state_form$.payer_company_id.$error,
            "validation-errors": _ctx.state_form$.payer_company_id.$errors,
            disabled: _ctx.data_state.payers.is_loading,
            label: "name",
            onRefresh: _ctx.loadPayers,
            onChange: _ctx.onPayerSelect,
            "infinite-scroll": ""
          }, null, 8, ["value", "options", "loading", "failed", "is-invalid", "validation-errors", "disabled", "onRefresh", "onChange"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_31, [
      _hoisted_32,
      _createVNode(_component_ok_radio, {
        options: _ctx.getPaymentMethods,
        value: _ctx.state.payment_method,
        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.payment_method) = $event)),
        onChange: _ctx.onPaymentMethodChange
      }, null, 8, ["options", "value", "onChange"]),
      (_ctx.isCanInputCash)
        ? (_openBlock(), _createBlock(_component_ok_input, {
            key: 0,
            class: "OkInput--white",
            name: "Сумма наличными",
            placeholder: "Введите сумму",
            value: _ctx.state.cash_sum,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.cash_sum) = $event)),
            "is-invalid": _ctx.state_form$.cash_sum.$error,
            "validation-errors": _ctx.state_form$.cash_sum.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ok_button, {
      type: "button",
      class: "OkButton--blue w-full mt-3",
      onClick: _ctx.emitSubmit,
      disabled: _ctx.is_loading,
      loading: _ctx.is_loading
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Сохранить изменения ")
      ]),
      _: 1
    }, 8, ["onClick", "disabled", "loading"])
  ]))
}